module.exports = __webpack_public_path__ + "img/arrow-white.a7ddbb1d.svg";